function normalizePath(path: string): string {
  if (path[0] === '/') {
    return path.slice(1);
  }
  return path;
}
export function createUrl(path: string): string {
  return window.location.origin + window.APP_CONFIG.BASE + normalizePath(path);
}

export function toUSLocaleString(value: number): string {
  return value.toLocaleString('en-US');
}
